class PromoQuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      // If the quick view is within the main product section, restore the "sticky" class
      const productContainer = this.closest('.product__info-container');

      if(productContainer) {
        if(productContainer.classList.contains('product__info-container--sticky--')) {
          productContainer.classList.remove('product__info-container--sticky--');
          productContainer.classList.add('product__info-container--sticky');
        }
      }
      
      this.querySelectorAll('drawer-close-button').forEach(button => {
        button.removeEventListener('click');
      });
    });
  }
}
customElements.define('promo-quick-view-drawer', PromoQuickViewDrawer);

class PromoQuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = document.querySelector(this.dataset.targetDrawer);
      const drawer = wrapper.querySelector('promo-quick-view-drawer');
      
      if (drawer) {
        // If the quick view is within the main product section, temporarily remove its "sticky" class
        const productContainer = this.closest('.product__info-container');

        if (productContainer) {
          if(productContainer.classList.contains('product__info-container--sticky')) {
            productContainer.classList.remove('product__info-container--sticky');
            productContainer.classList.add('product__info-container--sticky--');
          }
        }

        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            promoUrl: this.dataset.promoUrl
          }
        }));
      }
    });
  }
}
customElements.define('promo-quick-view-button', PromoQuickViewButton);

class PromoQuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const sectionUrl = `/pages/store-promotions/${ this.dataset.promoId }?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));

          const promoId = this.getAttribute('data-promo-id');
      
          this.querySelectorAll('drawer-close-button').forEach(button => {
            if( ! button.dataset.dismissPromotion) return true;

            button.addEventListener('click', () => {
              document.dispatchEvent(new CustomEvent('promo:dismissed', {
                detail: {
                  id: promoId
                }
              }));

              const body = JSON.stringify({ note: `promo dismissed: ${ this.dataset.promoId }` }),
                  updateOptions = {...fetchConfig(), ...{ body }};
  
              fetch(`${ theme.routes.cart_update_url }`, updateOptions);
            });
          });
      
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('promo-quick-view', PromoQuickView);